import type { WrapperProps } from "@/modules/companies/client/components/Wrapper/types"
import type { PagesRouterPageProps } from "@/types"
import type { FunctionComponent, ReactNode } from "react"

import { Error } from "@jobteaser/ui-kit/components/Error/Error"
import { Layout, LAYOUT_COLOR_BLOCK } from "@jobteaser/ui-kit/components/Layout/Layout"

import { CCTheme } from "@/modules/careerCenter/components/CCTheme"
import { ERROR_SERVER_SIDE_COMPANY } from "@/modules/companies/client/api/endpoints/company"
import { Breadcrumbs } from "@/modules/companies/client/components/Breadcrumbs/Breadcrumbs"
import { Header } from "@/modules/companies/client/components/Header/Header"
import { Menu } from "@/modules/companies/client/components/Menu/Menu"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"
import { COMPANY_BASENAME } from "@/modules/companies/client/utils/routing"
import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { FoLayout } from "@/modules/layouts/components/FoLayout"
import { useLocale } from "@/modules/locales/useLocale"

import "react-loading-skeleton/dist/skeleton.css"

export const Wrapper: FunctionComponent<PagesRouterPageProps<WrapperProps & { children: ReactNode }>> = props => {
  const { children, host, serverSideError, serverContext } = props
  const { baseUrl } = serverContext || { baseUrl: "" }
  const { t } = useTranslation(["companies_client"])
  const { dataCompany, isErrorCompany } = useCompanyFetch()
  const locale = useLocale()

  if (isErrorCompany || serverSideError === ERROR_SERVER_SIDE_COMPANY) {
    return (
      <CCTheme>
        <FoLayout host={host}>
          <Layout hasTopPadding hasBottomPadding isSmall colorBlock={LAYOUT_COLOR_BLOCK.WHITE}>
            <Layout.Column>
              <Error
                title={t("companies_client.error.404.title")}
                action={<a href={`/${locale}/${COMPANY_BASENAME}`}>{t("companies_client.error.404.link")}</a>}
              />
            </Layout.Column>
          </Layout>
        </FoLayout>
      </CCTheme>
    )
  }

  if (dataCompany) {
    return (
      <CCTheme>
        <FoLayout host={host}>
          <Layout hasTopPadding hasBottomPadding colorBlock={LAYOUT_COLOR_BLOCK.WHITE}>
            <Layout.Column>
              <Header baseUrl={baseUrl} />
            </Layout.Column>
          </Layout>
          <Layout hasBottomPadding colorBlock={LAYOUT_COLOR_BLOCK.WHITE}>
            <Layout.Column>
              <Menu />
            </Layout.Column>
          </Layout>
          {children}
          <Layout hasBottomPadding hasTopPadding colorBlock={LAYOUT_COLOR_BLOCK.WHITE}>
            <Layout.Column>
              <Breadcrumbs />
            </Layout.Column>
          </Layout>
        </FoLayout>
      </CCTheme>
    )
  }

  return null
}
